import Vue from 'vue'
import Router from 'vue-router'

import LayoutFirst from '@/views/layout/LayoutFirst'
import LayoutSecond from '@/views/layout/LayoutSecond'
import LayoutThree from '@/views/layout/LayoutThree'

Vue.use(Router)

export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: [{

    path: '',
    component: LayoutFirst,
    children: [
      {
        path: '/',
        redirect: '/family'
      },
      {
        path: 'health',
        component: () =>
                        import('@/views/health/index'),
        name: 'Health',
        meta: {
          title: '数据'
        }
      },

      {
        path: 'family',
        component: () =>
        import('@/views/family/index'),
        name: 'Family',
        meta: {
          title: '家人',
          i18n: 'a1'
        }
      }

    ]
  },
  {
    path: '',
    name: 'second',
    component: LayoutSecond,
    children: [
    // 健康数据
      {
        path: 'health/reports',
        component: () =>
                        import('@/views/health/reports'),
        name: 'HealthReports',
        meta: {
          title: '健康报告'
        }
      },
      // 健康数据
      {
        path: 'health/report',
        component: () =>
                        import('@/views/health/report'),
        name: 'HealthReport',
        meta: {
          title: '健康报告'
        }
      },
      {
        path: 'health/warning',
        component: () =>
                        import('@/views/health/warning'),
        name: 'warning',
        meta: {
          title: '健康预警'
        }
      },
      {
        path: 'health/suggest',
        component: () =>
                        import('@/views/health/suggest'),
        name: 'suggest',
        meta: {
          title: '健康建议'
        }
      },
      {
        path: 'family/applyList',
        component: () =>
          import('@/views/family/applyList'),
        name: 'applyList',
        meta: {
          title: '家人申请',
          i18n: 'a5'
        }
      },
      {
        path: 'health/bp',
        component: () =>
                        import('@/views/health/item/bp'),
        name: 'Bp',
        meta: {
          title: '血压'
        }
      },
      {
        path: 'health/bs',
        component: () =>
                        import('@/views/health/item/bs'),
        name: 'Bs',
        meta: {
          title: '血糖'
        }
      },
      {
        path: 'health/hb',
        component: () =>
                        import('@/views/health/item/hb'),
        name: 'Hb',
        meta: {
          title: '心率'
        }
      },
      {
        path: 'health/bo',
        component: () =>
                        import('@/views/health/item/bo'),
        name: 'Bo',
        meta: {
          title: '血氧'
        }
      },
      {
        path: 'health/step',
        component: () =>
                        import('@/views/health/item/step'),
        name: 'Step',
        meta: {
          title: '步数',
          i18n: 'a7'
        }
      },
      {
        path: 'health/hrv',
        component: () =>
                        import('@/views/health/item/hrv'),
        name: 'Hrv',
        meta: {
          title: 'HRV心脏指数'
        }
      },
      {
        path: 'health/pause',
        component: () =>
                        import('@/views/health/item/pause'),
        name: 'Pause',
        meta: {
          title: '呼吸暂停次数'
        }
      },
      {
        path: 'health/hbt',
        component: () =>
                        import('@/views/health/item/hbt'),
        name: 'Hbt',
        meta: {
          title: '心电',
          i18n: 'a13'
        }
      },
      {
        path: 'health/six-ecg',
        component: () =>
                        import('@/views/health/item/sixecg'),
        name: 'six-ecg',
        meta: {
          title: '专业心电'
        }
      },
      {
        path: 'health/hld',
        component: () =>
                        import('@/views/health/item/hld'),
        name: 'Hld',
        meta: {
          title: '心脏负荷'
        }
      },
      {
        path: 'health/as',
        component: () =>
                        import('@/views/health/item/as'),
        name: 'As',
        meta: {
          title: '动脉硬化指数'
        }
      },
      {
        path: 'health/bmi',
        component: () =>
                        import('@/views/health/item/bmi'),
        name: 'Bmi',
        meta: {
          title: 'BMI'
        }
      },
      {
        path: 'health/audio',
        component: () =>
                        import('@/views/health/item/audio'),
        name: 'Audio',
        meta: {
          title: '脏音',
          i18n: 'a6'
        }
      },
      {
        path: 'health/hbtEcg',
        component: () =>
                        import('@/views/health/item/hbtEcg'),
        name: 'hbtEcg',
        meta: {
          title: '专业心电'
        }
      },

      {
        path: 'logged/xy',
        component: () =>
                        import('@/views/logged/xy'),
        name: 'xy',
        meta: {
          title: '手动输入'
        }
      },
      {
        path: 'friend/warning',
        component: () => import('@/views/health-sos/warning'),
        name: 'friendWarning',
        meta: {
          title: 'sos预警',
          i18n: 'a17'
        }
      }, {
        path: 'health/measure',
        component: () =>
                        import('@/views/health/item/measure'),
        name: 'Measure',
        meta: {
          title: '健康分析',
          i18n: 'a18'
        }
      }, {
        path: 'friend/sos',
        component: () => import('@/views/health-sos/sos'),
        name: 'friendSos',
        meta: {
          title: 'sos报警',
          i18n: 'a17'
        }
      },
      {
        path: '/friend/sosmap',
        component: () => import('@/views/health-sos/goolemap'),
        name: 'friendSosmap',
        meta: {
          title: 'sos报警',
          i18n: 'a17'
        }
      }
    ]
  },

  {
    path: '',
    component: LayoutThree,
    children: [

      {
        path: 'family/add/nav',
        component: () =>
          import('@/views/family/addNav'),
        name: 'addNav',
        meta: {
          title: '添加家人'
        }
      },
      {
        path: 'familyApp/add/nav',
        component: () =>
          import('@/views/familyApp/addNav'),
        name: 'addNav',
        meta: {
          title: '添加家人'
        }
      },
      {
        path: 'family/apply',
        component: () =>
          import('@/views/family/apply'),
        name: 'apply',
        meta: {
          title: '新的家人'
        }
      },
      {
        path: 'familyApp',
        component: () =>
          import('@/views/familyApp/index'),
        name: 'Family',
        meta: {
          title: '家人'
        }
      },
      {
        path: 'family/bind',
        component: () =>
          import('@/views/family/bind'),
        name: 'bind',
        meta: {
          title: '账号绑定'
        }
      },
      {
        path: 'familyApp/bind',
        component: () =>
          import('@/views/familyApp/bind'),
        name: 'bind',
        meta: {
          title: '账号绑定'
        }
      },
      {
        path: 'familyApp/adddirectly',
        component: () =>
          import('@/views/familyApp/adddirectly'),
        name: 'adddirectly',
        meta: {
          title: '绑定账号',
          i18n: 'a2'
        }
      },
      {
        path: 'family/add',
        component: () =>
          import('@/views/family/add'),
        name: 'add',
        meta: {
          title: '新添家人',
          i18: 'a3'
        }
      }

    ]
  }
  ]
})

